import React from "react";

const Button = ({ text, src, link }) => {
  return (
    <button
      href={link}
      className="border text-white flex items-center px-10 py-3 space-x-2 border-primary"
    >
      <span>{text}</span>
      <img className="w-[25px]" src={src} alt="arrow-link" srcset="" />
    </button>
  );
};

export default Button;
